import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PhoneNumberProvider } from './components/utilits/Provided';

import './css/index.css';
// import './css/style.css';
import App from './components/App';
import store from './reducers';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <PhoneNumberProvider>
        <App />
      </PhoneNumberProvider>,
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
